module.exports = __webpack_public_path__ + "static/media/Danustan_Alphonza_danzilla_danustan_spicy_food_code_hobby_2_9.fb900373.jpg";